import { TweetContainer } from '@components/common/WYSIWYG/RenderHTMLText.styles';
import { useIntersectionObserver } from '@hooks/useIntersectionObserver';
import { TweetProps } from '@student-coin/coinpaper-components/dist/components/Tweet/Tweet.types';
import dynamic from 'next/dist/shared/lib/dynamic';
import { FC, useRef } from 'react';
import { TweetWidgetProps } from './TweetWidget.types';

const Tweet = dynamic(
  () => import('@student-coin/coinpaper-components').then((mod) => mod.Tweet as FC<TweetProps>),
  {
    ssr: false,
  },
);

export const TweetWidget: FC<TweetWidgetProps> = ({ tweetId }) => {
  const containerRef = useRef();
  const intersectionEntry = useIntersectionObserver(containerRef, {
    threshold: 0,
    freezeOnceVisible: true,
  });

  const inView = !!intersectionEntry?.isIntersecting;

  return <TweetContainer ref={containerRef}>{inView && <Tweet id={tweetId} />}</TweetContainer>;
};
